var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
export var getRowSelectionManager = function (isEnabled, data, uniqueColumnName, selectedRowsIds, onSelectedRowsChange) {
    var uniqueColumnValues = data.map(function (item) { return item[uniqueColumnName]; });
    var isAllRowsSelected = selectedRowsIds.length === uniqueColumnValues.length;
    var isMainCheckboxChecked = selectedRowsIds.length > 0;
    var isMainCheckboxIndeterminate = isMainCheckboxChecked && !isAllRowsSelected;
    var handleMainCheckboxChange = function () {
        if (isAllRowsSelected) {
            onSelectedRowsChange([]);
        }
        else {
            onSelectedRowsChange(uniqueColumnValues);
        }
    };
    var handleRowCheckboxChange = function (rowObject) {
        if (isRowSelected(rowObject)) {
            onSelectedRowsChange(selectedRowsIds.filter(function (q) { return q !== rowObject[uniqueColumnName]; }));
        }
        else {
            onSelectedRowsChange(__spreadArray(__spreadArray([], selectedRowsIds, true), [rowObject[uniqueColumnName]], false));
        }
    };
    var handleParentClick = function (event) {
        event.stopPropagation();
    };
    var isRowSelected = function (rowObject) {
        return selectedRowsIds.includes(rowObject[uniqueColumnName]);
    };
    return {
        isEnabled: isEnabled,
        isMainCheckboxChecked: isMainCheckboxChecked,
        isMainCheckboxIndeterminate: isMainCheckboxIndeterminate,
        isRowSelected: isRowSelected,
        onMainCheckboxChange: handleMainCheckboxChange,
        onRowCheckboxChange: handleRowCheckboxChange,
        onParentClick: handleParentClick
    };
};
//# sourceMappingURL=rowSelectionManager.js.map